import { FC } from 'react';

import type { ArticleOnce } from '@/entities/article';

import styles from './articleRecently.module.scss';
import ArticleSubCategoryList from '../ArticleSubCategoryList/ArticleSubCategoryList';


interface ArticleRecentlyProps {
  value: ArticleOnce;
}

const ArticleRecently: FC<ArticleRecentlyProps> = (props) => {
  const { value } = props;

  if (!value.next_articles.length) {
    return null;
  }
  return (
    <section className={styles.section}>
      <div className={styles.section__itemLeft}>
        <p className={styles.section__title}>Следующие статьи</p>
      </div>
      <ArticleSubCategoryList
        className={styles.section__itemRight}
        value={value.next_articles}
      />
    </section>
  );
};

export default ArticleRecently;
